module.exports = __webpack_public_path__ + "img/icon_map_3_on_010.4040d53f.png";